const isString = (maybeStr: any): maybeStr is string => {
  return typeof maybeStr === 'string';
};

export default isString;
